import { render, staticRenderFns } from "./bca.vue?vue&type=template&id=75debe21&scoped=true"
import script from "./bca.vue?vue&type=script&lang=js"
export * from "./bca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75debe21",
  null
  
)

export default component.exports